export const STUDIO_AI_EXCLUSIVE_OFFER_MODAL_DATA = 'studioAiExclusiveOfferModalData'
export const STUDIO_REFERRAL_CAPTURED_DATA = 'studioReferralCapturedData'
export const STUDIO_REFERRAL_CODE_STORAGE_KEY = 'studioReferralCode'
